import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError, from } from 'rxjs';
import { DataSourceService } from './data-source.service';
let API_PREFIX = 'api';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  constructor(private http: HttpClient, private dataSource: DataSourceService) { }

  exportAuditData():Observable<Blob> {
    return this.dataSource.exportAuditData();
  }
  exportMaterialData():Observable<Blob> {
    return this.dataSource.exportMaterialData();
  }
  exportSupplierReport():Observable<Blob> {
    return this.dataSource.exportSupplierReport();
  }

  exportUserReport():Observable<Blob> {
    return this.dataSource.exportUserReport();
  }
}
